module.exports = __webpack_public_path__ + "static/media/24UHCHR16.e7e617d3.jpg";